module.exports = __webpack_public_path__ + "static/img/noticia9.fe5c1a5f.jpg";